import React from 'react';
import Cookies from 'js-cookie'
import logo from '../logo.svg';
import './Home.css';
import CoachHome from './Coach/CoachHome';
import Programs from './Admin/Programs';

function Home() {

  const userType = Cookies.get('userType')
  switch (userType) {
    case 'admin':
    case 'adminViewOnly':
    case 'owner':
      return <Programs />
    case 'director':
    case 'coach':
      return <CoachHome />
    default:
      return (
        <div className="Home">
          <header className="Home-header">
            <img src={logo} className="Home-logo" alt="logo" />
            <p>
              Edit <code>src/Home.js</code> and save to reload.
            </p>
            <a
              className="Home-link"
              href="https://reactjs.org"
              target="_blank"
              rel="noopener noreferrer"
            >
              Learn React
            </a>
          </header>
        </div>
      );
  }
}

export default Home;
